interface CartItemMoqNoticeProps {
  item: {
    sku: { moq: number };
    quantity?: number;
  };
}

const CartItemMoqNotice = ({ item: { sku, quantity } }: CartItemMoqNoticeProps) => {
  if (!sku.moq || sku.moq <= 0) return null;

  const belowMoq = typeof quantity === 'number' && quantity < sku.moq;

  return (
    <div
      role="alert"
      className={`mt-1 inline-block flex-none w-auto rounded-md p-2 text-sm ${
        belowMoq ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'
      }`}
    >
      Min. Order Quantity: <span>{sku.moq}</span>
    </div>
  );
};

export default CartItemMoqNotice;
